export default import.meta.ROLLDOWN_FILE_URL_U1Sn7blGKysKHVgZoLyVVQ